import {Platform, Text, View, StyleSheet,Button, Alert, Modal,FlatList, Image, TouchableOpacity } from 'react-native'
import { useNavigation } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';
import * as FileSystem from 'expo-file-system';

const CuadroTema = ({ titulo,codigo,tipo,descripcion,color,contenido }) => {

    console.log("----------------Cuadro de Tematica-----------------")
    const navigation = useNavigation();
    const tailwind = useTailwind();

    let GoTema = (object) => {
      console.log("presionado");
      navigation.navigate( "Tema",{ titulo,contenido } );
    }
  
    console.log("cuadro tema");
    console.log(titulo);
    console.log(contenido);

//tailwind( "bg-matcon" + color + " uppercase text-lg text-center py-4")

    return (
      <View style ={ tailwind("bg-white overflow-hidden m-4 w-full md:w-5/12 lg:w-5/12 xl:w-3/12") }>
        <TouchableOpacity  onPress={ GoTema }  style ={ tailwind( "bg-matcon" + color + " uppercase text-lg text-center py-4") }>
          <Text style={ tailwind("font-bold text-white") }>{titulo["esp"]}</Text>
        </TouchableOpacity>
        <View style ={ tailwind("bg-gray-100 mx-2 p-4 md:min-h-[232px]")}>
          <Text style={ tailwind("text-justify") }>{descripcion["esp"]}</Text>
        </View>
        <View style ={ tailwind("flex flex-row flex-wrap justify-center mt-2") }>
          <TouchableOpacity  onPress={ GoTema }  style={ tailwind("text-xs bg-matconblue text-gray-800 p-4  px-14 rounded-md justify-center") }>
            <Text style={ tailwind("font-bold uppercase text-white text-center") }>Ver mas</Text>
          </TouchableOpacity>
        </View>
      </View>
    );
    
};


export default CuadroTema